/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { db_DropdownCourseCheckLevel } from '../models/db_DropdownCourseCheckLevel';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class CourseCheckLevels {
    /**
     * Get a list of course check levels
     * @returns db_DropdownCourseCheckLevel OK
     * @throws ApiError
     */
    public static listCourseCheckLevels(): CancelablePromise<Array<db_DropdownCourseCheckLevel>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/course-check-levels',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }
}
